/* eslint-disable import/prefer-default-export */
import get from 'lodash/fp/get';

export const calculateTotalPay = (groupPay) => {
  if (!groupPay) {
    return 'Error';
  }

  let payMessage;
  const min = get('min', groupPay, 'error');
  const max = get('max', groupPay, 'error');
  if (min === 'error' || max === 'error') {
    payMessage = 'Error';
  } else if (min === max) {
    payMessage = `$${max.toFixed(2)}`;
  } else {
    payMessage = `$${min.toFixed(2)}-$${max.toFixed(2)}`;
  }

  return payMessage;
};

export const calculateTotalJobPay = (jobInfo) => {
  if (!jobInfo) {
    return 'Error';
  }
  const { payRateReg, start, end } = jobInfo;
  const ONE_HOUR_IN_MS = 3600000;
  const differenceInHours = (end - start) / ONE_HOUR_IN_MS;
  const pay = differenceInHours * payRateReg;

  return `$${pay.toFixed(2)}`;
};
